import {
  AUTHORIZE_LIST_GET,
  AUTHORIZE_INFO_LIST_GET,
  ACTIVE_LIST_GET,
  ACTIVE_DETAIL_GET,
} from "../../fetch/url";
import { curl } from 'zh-common-modules';
import { actionTypes } from "./constants";

export const setAuthorizeList = data => ({
  type: actionTypes.SET_AUTHORIZE_LIST,
  data
});

export const setAuthorizeInfoList = data => ({
  type: actionTypes.SET_AUTHORIZE_INFO_LIST,
  data
});

export const setActiveList = data => ({
  type: actionTypes.SET_ACTIVE_LIST,
  data
});

export const setActiveDetail = data => ({
  type: actionTypes.SET_ACTIVE_DETAIL,
  data
});

export const setAuthorizeModel = data => ({
  type: actionTypes.SET_AUTHORIZE_MODEL,
  data
});

export const getAuthorizeList = (params) => {
  return dispatch => {
    curl
      .get(AUTHORIZE_LIST_GET, params)
      .then((res) => {
        dispatch(setAuthorizeList({
          list: res.rows,
          total: res.total,
        }));
      });
  };
};

export const getAuthorizeInfoList = (params) => {
  return dispatch => {
    curl
      .get(AUTHORIZE_INFO_LIST_GET, params)
      .then((res) => {
        dispatch(setAuthorizeInfoList({
          list: res.rows,
          total: res.total,
        }));
      });
  };
};

export const getActiveList = (params) => {
  return dispatch => {
    curl
      .get(ACTIVE_LIST_GET, params)
      .then((res) => {
        dispatch(setActiveList({
          list: res.rows,
          total: res.total,
        }));
      });
  };
};

export const getActiveDetail = (params) => {
  return dispatch => {
    curl
      .get(ACTIVE_DETAIL_GET, params)
      .then((res) => {
        dispatch(setActiveDetail(res));
      });
  };
};
